const state = {
  visible: false
}

const mutations = {
  SET_VISIBLE(state, visible) {
    state.visible = visible
  }
}

const actions = {
  openVipCard({ commit }) {
    commit('SET_VISIBLE', true)
  },
  closeVipCard({ commit }) {
    commit('SET_VISIBLE', false)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
